
































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InlineEdit extends Vue {
	@Prop({ required: true, type: String })
	public value!: string;

	@Prop({ required: false, type: Boolean })
	public shouldRenderHtml!: boolean;

	@Prop({ required: true, type: Function })
	public onValueChanged!: (newValue: string) => void;

	@Prop({ required: true, type: Function })
	public onCancel!: () => void;

	@Prop({ required: true, type: Function })
	public onSave!: () => Promise<void>;

	@Prop({ required: false, type: Boolean, default: false })
	public isTextArea!: boolean;

	public editing: boolean = false;

	public toggleEditing(): void {
		this.editing = !this.editing;
		if (this.editing === false) {
			this.onCancel();
		}
	}

	public async save(): Promise<void> {
		await this.onSave();
		this.editing = false;
	}
}
